import React, { useState, useEffect, useContext } from "react";
import pClasses from "../../ListUsersAndAdmins.module.scss";
import FriendlyInfo from "../../../FriendlyInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAlt, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Statistics } from "../../../../interfaces/Statistics";
import * as h from "../../../../helpers";
import InputText from "../../../Inputs/InputTextReport";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import RoundButton from "../../../Buttons/RoundButton";
// import useFetch from "../../../../hooks/useFetch";
import * as a from "../../../../constants/api";
import SessionContext from "../../../../context/sessionContext";
// import Spinner from "../../../../components/Spinner";

interface Interface {
  gamesInfo?: any;
  users?: any;
  date?: any;
  style?: any;
  className?: string;
  companyUid?: string | null;
  choosedShot?: string | null;
  showUser?: boolean;
  hideFilter?: boolean;
  showActiveStatus?: boolean;
  showBirthdate?: boolean;
  showCompany_uid?: boolean;
  showAccess_code?: boolean;
}

export default function ListUsers({ gamesInfo, className = "", users = null, choosedShot = "1" }: Interface) {
  const { t } = useTranslation();
  const ref: any = React.createRef();
  const cSession = useContext(SessionContext);
  const { user } = cSession ?? {};

  const [filterID, setFilterID] = useState("");
  const [toHide, setHiddenInfo] = useState(false);
  useState<string | null>(null);
  let _filtersArea = null;
  const getTableBody = (gamesInfo: any) => {
    if (!gamesInfo) return [];

    // Filtrar jogos pela jornada e pelo filtro de ID
    const _list = gamesInfo
      ?.filter((game: any) => String(game.journey) === String(choosedShot))
      ?.filter((game: any) =>
        !filterID || game.game_name?.toLowerCase().includes(filterID.toLowerCase())
      );

    if (_list.length > 0) {
      return _list.map((statistic: Statistics) => {
        /**DATE MOUNTH */
        let date: any = h.getFormattedDate(statistic.date_created)?.split("/");
        date[1] = t("months." + date[1]).substring(0, 3);
        date = date.join("/");

        /**SCORE COLOR */
        const { color = null, colorBorder = null } = h.getColorsScores(
          statistic.play_score
        );
        const isGame = statistic.game_level ? true : false;

        const bgAndBorderStyle: any = isGame
          ? {
            backgroundColor: color,
            borderColor: colorBorder,
          }
          : {};

        const play_score = isGame ? statistic.play_score : "-";
        return (
          <tr key={statistic.user_id}>
            {/* mobile */}
            <td className={pClasses.TdMobile}>
              <section className={pClasses.VertInfos}>
                <div className={pClasses.SideBySide}>
                  <label className={pClasses.Label}>
                    {statistic.game_name ?? ""}
                  </label>
                  <div className={"center"}>
                    <span className={pClasses.Label}>
                      {t("global.level")} {statistic.game_level}
                    </span>
                  </div>
                </div>
                <>
                  <br />
                  <div className={pClasses.SideBySide}>
                    <div className={pClasses.InfosArea}>
                      <div className={pClasses.Infos}>
                        <label className={pClasses.Label}>
                          {t("global.time")}
                        </label>
                      </div>
                      <div className={pClasses.Infos}>
                        <span>{statistic.play_time}</span>
                      </div>
                    </div>
                    <div className={pClasses.TitleAreaReport}>
                      <div>
                        <label className={pClasses.Label}>
                          {t("global.score")}
                        </label>
                      </div>
                      <div>
                        <span
                          className={isGame ? pClasses.TagScore : ""}
                          style={bgAndBorderStyle}
                        >
                          {play_score}
                        </span>
                      </div>
                    </div>
                    <div className={pClasses.InfosArea}>
                      <div>
                        <label className={pClasses.Label}>
                          {t("global.date")}
                        </label>
                      </div>
                      <div className={pClasses.Infos}>
                        <span>{date}</span>
                      </div>
                    </div>
                  </div>
                </>
              </section>
            </td>

            {/* desktop */}
            <td className={pClasses.TdReport}>
              <b>{statistic.game_name}</b>
            </td>
            <td className={pClasses.TdReport}>{statistic.game_level}</td>
            <td className={pClasses.TdReport}>
              <span
                className={isGame ? pClasses.TagScore : ""}
                style={bgAndBorderStyle}
              >
                {play_score}
              </span>
            </td>
            <td className={pClasses.TdReport}>{statistic.play_time}</td>
            <td className={pClasses.TdReport}>{statistic.journey}</td>
            <td className={pClasses.TdReport}>{date}</td>
          </tr>
        );
      });
    } else {
      return [];
    }
  };

  let _content = <></>

  _filtersArea = (
    <>
      <div className={pClasses.FiltersArea}>
        <div className={pClasses.InputLimit}>
          <InputText
            value={filterID}
            onChange={setFilterID}
            label={t("global.game_name")}
          />
        </div>
        <div className={pClasses.Spacer} />
      </div>
    </>
  );

  const relat = new URL(window.location.href);
  let caixa = [] as Array<any>;
  caixa = relat.pathname.split("/").reverse();

  const nameUser = decodeURIComponent(caixa[1]).replace(/\./g, "");

  _content = (
    <>
      <RoundButton
        small
        className={pClasses.BtnPdfSecondary}
        text={t("global.print_partial_report")}
        faIcon={faFilePdf}
        title={t("BAIXAR PDF")}
        onClick={() => pdfDownload()}
      />

      <div id={ref} className={pClasses.PdfPrint}>
        <div id="refName" className={pClasses.hiddenName}>
          {decodeURIComponent(caixa[1]) && (
            <h1>Usuário: {decodeURIComponent(caixa[1])}</h1>
          )}
        </div>
        <table className={pClasses.TableResponsiveCenter}>
          <thead className={pClasses.TableHeadCenter}>
            <tr className={pClasses.TdHeigth}>
              <th className={pClasses.TdMobile}>{t("global.plays")}</th>
              <th className={pClasses.TdReport}>{t("global.game")}</th>
              <th className={pClasses.TdReport}>{t("global.level")}</th>
              <th className={pClasses.TdReport}>{t("global.score")}</th>
              <th className={pClasses.TdReport}>{t("global.time")}</th>
              <th className={pClasses.TdReport}>{t("global.journey")}</th>
              <th className={pClasses.TdReport}>{t("global.date")}</th>
            </tr>
          </thead>
          <tbody className={pClasses.TableBody}>
            {getTableBody(gamesInfo)}
          </tbody>
        </table>
      </div>

      <div
        className={pClasses.Accessibility + " " + (toHide ? pClasses.Hide : "")}
        onClick={() => setHiddenInfo(true)}
      >
        <FontAwesomeIcon icon={faArrowsAlt} />
      </div>
    </>
  );

  if (gamesInfo?.length === 0)
    _content = <FriendlyInfo text={t("infos.user_without_plays")} />;

  const pdfDownload = () => {
    const input: any = document.getElementById(ref);
    html2canvas(input, {
      // scrollX: -window.scrollX,
      // scrollY: -window.scrollY,
      // windowWidth: document.documentElement.offsetWidth,
      // windowHeight: document.documentElement.offsetHeight,
    }).then((canvas: any) => {
      const pdf = new jsPDF("p");
      const imgData = canvas.toDataURL("image/png");
      const height = (pdf.getImageProperties(imgData).height * 350) / 1800;
      let heightLeft = height;
      let position = 0;
      pdf.getImageProperties(imgData).width < 1200
        ? pdf.addImage(imgData, "png", 0, 0, 210, height)
        : pdf.addImage(imgData, "png", 0, 0, 210, height / 1.5055);
      heightLeft -= pdf.internal.pageSize.height;
      while (heightLeft >= 0) {
        position = heightLeft - height;
        pdf.addPage();
        pdf.addImage(imgData, "png", 0, position, 210, 60);
        heightLeft -= pdf.internal.pageSize.height;
      }
      pdf.save(`${user ? String(user?.registry).replace(".", "_") : nameUser?.replace(".", "_")}_Jogos_Audiofoco.pdf`);
    });
  };
  return (
    <>
      {_filtersArea}
      <div className={className + " " + pClasses.TableArea}>{_content}</div>
    </>
  );
}
